/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetIdPrivRequestApiFrom } from '../../models/set-id-priv-request-api-from';

export interface ApiV3ServiceSetIdPrivPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: SetIdPrivRequestApiFrom
}

export function apiV3ServiceSetIdPrivPost(http: HttpClient, rootUrl: string, params?: ApiV3ServiceSetIdPrivPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceSetIdPrivPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceSetIdPrivPost.PATH = '/api/v3/service/SetIdPriv';
